import { API_ERROR } from 'home/view/upgrade-order/constants';

const isApiSuccess = (res) => res && res.status && res.status === 200;

const getErrMsg = (err) => {
  return (err && err.response && err.response.data && err.response.data.errorMsg) || API_ERROR.DEFAULT_MSG;
};

export { isApiSuccess, getErrMsg };
